(ns machtfit.dashboard.stepchall.form.route-editor.core
  (:require [machtfit.dashboard.stepchall.form.core :as-alias form]
            [machtfit.dashboard.stepchall.form.route-editor.path :as path]
            [machtfit.dashboard.stepchall.form.route-editor.shared :as shared]
            [machtfit.stepchall.catmullrom :as catmullrom]
            [machtfit.stepchall.route-view :as route-view]
            [machtfit.stepchall.subs :refer [prepare-stages]]
            [re-frame.core :as rf]))

(defn- toggle-edit-mode [db]
  (update-in db [:ui :stepchall :route-edit :enabled?] not))

(defn- set-key-modifiers [db event]
  (assoc-in db [:ui :stepchall :route-edit :key-modifiers]
            {:shift? (.-shiftKey event)}))

(rf/reg-event-db ::key-down
  (fn [db [_ event]]
    (-> db
        (set-key-modifiers event)
        (cond->
          (-> event .-code (= "KeyE")) toggle-edit-mode))))

(rf/reg-event-db ::key-up
  (fn [db [_ event]]
    (set-key-modifiers db event)))

(rf/reg-sub ::catmullrom-curve
  :<- [:get [:challenge :theme :path]]

  (fn [theme-path _]
    (catmullrom/catmullrom theme-path)))

(rf/reg-sub ::path-leg-lengths
  :<- [:get [:challenge :theme :path]]

  (fn [theme-path _]
    (catmullrom/path->leg-lengths theme-path)))

(rf/reg-sub ::stages
  :<- [:get [:challenge :config :stages]]
  :<- [:get [:challenge :config :goal]]
  :<- [::catmullrom-curve]
  :<- [::path-leg-lengths]

  (fn [[stages goal catmullrom-curve leg-lengths] _]
    (prepare-stages stages goal catmullrom-curve leg-lengths)))

(defn- route-edit-view []
  [:div.sc_route-view
   [:img {:style {:width "100%"}
          :src @(rf/subscribe [:get [:challenge :route :background-image :url]])}]
   [:svg {:id shared/route-editor-svg-id
          :style {:position "absolute"
                  :top 0
                  :left 0
                  :right 0
                  :width "100%"
                  :height "100%"}
          :view-box (str "0 0 " shared/max-x " " shared/max-y)
          :preserve-aspect-ratio "xMidYMin meet"
          :on-mouse-up path/on-mouse-up
          :on-mouse-move path/on-mouse-move}
    [route-view/route-path [::catmullrom-curve]]
    [route-view/stage-markers [::stages]]
    [route-view/stage-marker-texts [::stages]]
    [path/theme-path-points]]])

(rf/reg-event-db ::edit-button-clicked
  (fn [db _]
    (toggle-edit-mode db)))

(defn- controls []
  (let [edit-mode @(rf/subscribe [::form/effective-edit-mode])]
    [:div {:style {:padding-bottom "2px"}}
     [:button {:on-click #(rf/dispatch [::edit-button-clicked])
               :style {:outline "none"
                       :margin-right "3px"
                       :border "1px solid #ccc"
                       :background-color (if edit-mode
                                           "#008ca0"
                                           "#fff")
                       :color (if edit-mode
                                "#fff"
                                "#000")}}
      "edit"]
     " "
     (if edit-mode
       "SHIFT: hinzufügen/entfernen, Dbl-Klick: Zwischenziel markieren"
       "E: Edit-Modus an-/ausschalten")]))

(defn route-editor []
  [:div.col.s6.route-editor
   {:on-key-down #(rf/dispatch [::key-down %])
    :on-key-up #(rf/dispatch [::key-up %])
    ;; this is required to be able to tab to the element, but also to gain focus
    ;; and capture key events, otherwise the handlers above won't do anything
    :tab-index 0
    :style {:outline 0}}
   [controls]
   [route-edit-view]])
